import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Text } from "react-native-paper";
import { themeRoundnessMultiplier } from "../constants";
import { useAppTheme } from "../useAppTheme";
import Box from "./Box";

export type AnswerStatus = "correct" | "incorrect" | "skipped";

type AnswerStatusChipProps = {
	status: AnswerStatus;
	label: string;
	fontSize?: number;
	minWidth?: number;
	gap?: number;
};

const AnswerStatusChip = ({
	status,
	label,
	fontSize = 14,
	minWidth = 68,
	gap = 8,
}: AnswerStatusChipProps) => {
	const theme = useAppTheme();
	const getBgColor = () => {
		switch (status) {
			case "correct":
				return theme.colors.confidence.high;
			case "incorrect":
				return theme.colors.confidence.low;
			case "skipped":
				return theme.colors.progress.noneBackground;
			default:
				return undefined;
		}
	};

	const getIcon = () => {
		switch (status) {
			case "correct":
				return "check";
			case "incorrect":
				return "close";
			case "skipped":
				return "minus-circle-outline";
			default:
				return undefined;
		}
	};
	return (
		<Box
			style={{
				backgroundColor: getBgColor(),
				minWidth,
				minHeight: 32,
				borderRadius: theme.roundness * themeRoundnessMultiplier,
				padding: 6,
			}}
			flexDirection="row"
			alignItems="center"
			justifyContent="center"
			gap={gap}
		>
			<Icon name={getIcon()} size={18} color={theme.colors.white} />
			<Text
				variant="labelMedium"
				style={{
					color: theme.colors.white,
					fontSize,
					lineHeight: 0,
				}}
			>
				{label}
			</Text>
		</Box>
	);
};

export default AnswerStatusChip;
